<template>
  <v-ons-page>
    <v-ons-toolbar modifier="">
      <div class="left">
        <v-ons-back-button>
        </v-ons-back-button>
      </div>
      <div class="center flex-column justify-content-center align-items-center">
        Product
      </div>
      <div class="right">
        <v-ons-toolbar-button @click="toggleFavorite(product)">
          <i v-show="product.fav" class="fa fa-star"></i>
          <i v-show="!product.fav" class="fa fa-star-o"></i>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <v-ons-list>

      <div v-html="product.DetailsSvg"></div>

    </v-ons-list>

  </v-ons-page>
</template>

<script>
import { appData } from '../data.js'

export default {
  name: 'graphic',
  props: {
    product: Object,
  },
  data () {
    return {

    }
  },
  methods: {
    toggleFavorite(product) {
      appData.toggleFavorite(product);
    }
  },

}
</script>

<style scoped>
  .fa-star, .fa-star-o {
    color: #dcca72;
  }

  .details {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Graphic.vue